export const LOGIN  = 'LOGIN';
export const SIGNUP = 'SIGNUP';
export const LOGOUT = 'LOGOUT';
export const RESET = 'RESET';
export const SHOWLOGIN = 'SHOW_LOGIN';